import { atom } from 'recoil'

export const companyListAtom = atom({
  key: 'companyList',
  default: false
})
